import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace ReportsFields {
  export enum DefaultValuesField {
    DefaultDomainReportCategory = 'DefaultDomainReportCategory',
    DefaultDomainReportName = 'DefaultDomainReportName',
  }

  export enum IzendaReportsField {
    DynamicDatasourceIncludedFields = 'IzendaReports.DynamicDatasourceIncludedFields',
    EnableAcrossRoomReports = 'IzendaReports.EnableAcrossRoomReports',
    EnableReportsList = 'IzendaReports.EnableReportsList',
    EnableDesigner = 'IzendaReports.EnableDesigner',
    LimitOfRecords = 'IzendaReports.LimitOfRecords',
    OrganizationFilter = 'IzendaReports.OrganizationFilter',
    ResultsListItems = 'IzendaReports.ResultsListItems',
    DomainReports = 'IzendaReports.DomainReports',
    DefaultReportCategory = 'IzendaReports.DefaultReportCategory',
    DefaultReportName = 'IzendaReports.DefaultReportName',
    ExcludeDeletedDocsForPageCount = 'IzendaReports.ExcludeDeletedDocsForPageCount',
    EnableReportsForAllUsers = 'IzendaReports.EnableReportsForAllUsers',
    ReaderReportCategory = 'IzendaReports.ReaderReportCategory',
    ReaderReportName = 'IzendaReports.ReaderReportName',
    EditorReportCategory = 'IzendaReports.EditorReportCategory',
    EditorReportName = 'IzendaReports.EditorReportName',
    AdminReportCategory = 'IzendaReports.AdminReportCategory',
    AdminReportName = 'IzendaReports.AdminReportName',
    SuperAdminReportCategory = 'IzendaReports.SuperAdminReportCategory',
    SuperAdminReportName = 'IzendaReports.SuperAdminReportName',
    ReportsSystem = 'Reports.ReportsSystem',
  }

  export enum ReportsField {
    HeatmapSettings = 'Reports.HeatmapSettings',
    EnableKpiDashboard = 'Reports.EnableKpiDashboard',
  }
}

class DefaultValues extends SettingsSubModule {
  @SettingsSubModule.value(ReportsFields.DefaultValuesField.DefaultDomainReportCategory, 'Standard Domain Reports')
  defaultDomainReportCategory: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.DefaultValuesField.DefaultDomainReportName, 'Across Study Reports')
  defaultDomainReportName: SettingValue<string>;
}

class IzendaReportsConfig extends SettingsSubModule {
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.DynamicDatasourceIncludedFields, '')
  dynamicDatasourceIncludedFields: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.EnableAcrossRoomReports, false)
  enableAcrossRoomReports: SettingValue<boolean>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.EnableReportsList, false)
  enableReportsList: SettingValue<boolean>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.EnableDesigner, false)
  enableDesigner: SettingValue<boolean>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.LimitOfRecords, 10000) limitOfRecords: SettingValue<number>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.OrganizationFilter, '')
  organizationFilter: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.ResultsListItems, '100\r\n1000\r\n3000\r\n5000')
  resultsListItems: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.DomainReports, '[]') domainReports: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.DefaultReportCategory, 'Standard Dashboards')
  defaultReportCategory: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.DefaultReportName, 'Document Review')
  defaultReportName: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.ExcludeDeletedDocsForPageCount, false)
  excludeDeletedDocsForPageCount: SettingValue<boolean>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.EnableReportsForAllUsers, false)
  enableReportsForAllUsers: SettingValue<boolean>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.ReaderReportCategory, 'Standard Dashboards')
  readerReportCategory: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.ReaderReportName, 'Document Review')
  readerReportName: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.EditorReportCategory, 'Standard Dashboards')
  editorReportCategory: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.EditorReportName, 'Document Review')
  editorReportName: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.AdminReportCategory, 'Standard Dashboards')
  adminReportCategory: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.AdminReportName, 'Document Review')
  adminReportName: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.SuperAdminReportCategory, 'Standard Dashboards')
  superAdminReportCategory: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.SuperAdminReportName, 'Document Review')
  superAdminReportName: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.IzendaReportsField.ReportsSystem, 'Jasper')
  reportsSystem: SettingValue<string>;
}

class ReportsConfig extends SettingsSubModule {
  @SettingsSubModule.value(ReportsFields.ReportsField.HeatmapSettings, '') heatmapSettings: SettingValue<string>;
  @SettingsSubModule.value(ReportsFields.ReportsField.EnableKpiDashboard, false)
  enableKpiDashboard: SettingValue<boolean>;
}

export class ReportsModule extends SettingsModule {
  @SettingsModule.value(DefaultValues) defaultValues: DefaultValues;
  @SettingsModule.value(IzendaReportsConfig) izendaReports: IzendaReportsConfig;
  @SettingsModule.value(ReportsConfig) reports: ReportsConfig;
}
